// extracted by mini-css-extract-plugin
export default {"ace-c-document-upload-panel-item__description":"document-upload-panel-item__description---45c37370"};